import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// Re-export button variants for MockDetector widget
export { buttonVariants, type ButtonVariantsProps } from "./button-variants"
